import Header from "../Header/Header";
import PageHeader from "./PageContent/PageHeader";

const Extractpdf = () => {
  return (
    <section className="extract-pdf-mainsection pb-0">
      <Header />
      <PageHeader />
    </section>
  );
};
export default Extractpdf;
